import {enableProdMode, ViewEncapsulation} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from '@app/app.module';
import {environment} from '@environment/environment';
// import {Settings} from "luxon";

// Timezone and locale config
// Settings.defaultZone = 'utc';
// Settings.defaultLocale = "en-US";

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, {
  defaultEncapsulation: ViewEncapsulation.ShadowDom
}).catch(err => console.error(err));
